type GeoType = { lat: number | string; lng: number | string }
export function geoDistanceInMeters({ from, to, }: { to: GeoType; from: GeoType }) {
    const initLat = Number(to?.lat)
    const initLng = Number(to?.lng)
    const fromLat = Number(from?.lat)
    const fromLng = Number(from?.lng)
    // The math module contains a function
    // named toRadians which converts from
    // degrees to radians.
    const initLn = (initLng * Math.PI) / 180;
    const fromLn = (fromLng * Math.PI) / 180;
    const initLa = (initLat * Math.PI) / 180;
    const fromLa = (fromLat * Math.PI) / 180;

    // Haversine formula
    let dlon = fromLn - initLn;
    let dlat = fromLa - initLa;
    let a =
        Math.pow(Math.sin(dlat / 2), 2) +
        Math.cos(initLa) * Math.cos(fromLa) * Math.pow(Math.sin(dlon / 2), 2);

    let c = 2 * Math.asin(Math.sqrt(a));

    // Radius of earth in kilometers. Use 3956
    // for miles
    let r = 6371000;

    // calculate the result
    return (c * r).toFixed(2);
}